import { Session } from "../helpers/Models";
import { environment, extension_endpoint, nextJsEndpoint } from "../utils/constants";

export const url_get_session_id = extension_endpoint + "/get_portals_session_id";

export const opinionUrl = nextJsEndpoint[environment] + "/api/opinion/{{opinion_id}}";

export const getOpinionPlainText = async ({
  opinionId,
  getToken,
}: {
  opinionId: string;
  getToken: () => Promise<string | null>;
}) => {
  const token = await getToken();
  if (!token || !opinionId) {
    console.debug("getOpinionPlainText no token or no sessionId");
    return null;
  }
  const headers: Record<string, string> = {};
  headers["Content-Type"] = "application/json";
  headers["Authorization"] = `Bearer ${token}`;

  try {
    const url = opinionUrl.replace("{{opinion_id}}", opinionId);
    const res = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const json = await res?.json();
    return json;
  } catch (error) {
    console.log("getOpinionPlainText error", error);
  }
  return null;
};
